import { useMemo, useState } from "react";
import ContentList from "../../../customUiForCs/ContentList";
import SiteCard from "../sites/SiteCard";
import ZoneDropDownInput from "../sites/ZoneDropDownInput";
import SiteDropDownInput from "../employees/SiteDropDownInput";
import MaterialInput from "../../../helperComponents/MaterialInput";
import VacationCard from "../vacation/VacationCard";
import DisputeCard from "../disputes/DisputeCard";

export default function NomenclatureOfDispute({
  userID,
  disableFilters,
  inheritedSearchQuery,
  callback,
}) {
  const [zoneID, setZoneID] = useState(null);
  const [siteID, setSiteID] = useState(null);
  const [date, setDate] = useState(null);

  const queryParams = useMemo(
    () => ({ zoneID, siteID, date }),
    [zoneID, siteID, date]
  );

  return (
    <ContentList
      callback={callback}
      disableFilters={disableFilters}
      inheritedSearchQuery={inheritedSearchQuery}
      //
      userID={userID}
      doReset={() => {
        setZoneID(null);
        setSiteID(null);
        setDate(null);
      }}
      permissionName={"disputePermissions"}
      queryParams={queryParams}
      filters={
        <>
          <MaterialInput
            type="date"
            label={"Date"}
            value={date}
            onChange={(e) => {
              setDate(e.target.value);
            }}
          />
          <SiteDropDownInput onChange={setSiteID} value={siteID} label="Site" />
          <ZoneDropDownInput onChange={setZoneID} value={zoneID} label="Zone" />
        </>
      }
      title="Contentieux"
      path="disputes"
      CardComponent={DisputeCard}
    />
  );
}
